/**
 * @description 单元格保护功能工具类 - 将一些业务无关的代码抽离出来
 *  与 CellProtectCtrl 类无关的 不需要 this 参与的方法
 */

import luckysheetConfigsetting from "../controllers/luckysheetConfigsetting";
import Store from "../store";
import { setRangeShow } from "../global/api";
import { luckysheetrefreshgrid } from "../global/refresh";
import { getSheetIndex } from "../methods/get";
import luckysheetsizeauto from "../controllers/resize";
import server from "../controllers/server";
/**
 * @description 获取保护范围弹窗HTML
 * @param {*} rangeText 保护范围文本
 * @returns 保护范围弹窗HTML
 */
function getModalHtml(rangeText) {
    return `
        <div id="luckysheet-modal-dialog-cell-protect-config" class="luckysheet-modal-dialog luckysheet-modal-dialog-cell-protect-config">
            <div class="luckysheet-modal-dialog-title">
                <span>保护范围 - ${rangeText}</span>
                <span class="luckysheet-modal-dialog-title-close">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="luckysheet-modal-dialog-content">
                <div class="segmented-control">
                    <button id="mode-only-me" class="active">仅我可编辑</button>
                    <button id="mode-specific">指定人员权限</button>
                </div>

                <!-- 仅我可编辑 -->
                <div class="container-item" id="container-item-permission-onlyme">
                    <div class="container-item-title">💡权限说明：</div>
                    <div class="container-item-content">
                        <p>仅查看：仅能查看范围内容，不能编辑</p>
                        <p>可编辑：能查看范围内容，也能编辑</p>
                        <p>不可查看：不能查看范围内容，也不能编辑</p>
                    </div>
                    <div class="container-item-title">⚠️权限冲突：</div>
                    <div class="container-item-content">
                        <p>如果配置权限有冲突，以权限最高的为准，规则：可编辑 > 仅查看 > 不可查看</p>
                        <p>注意：文件所有者拥有全部权限</p>
                    </div>
                </div>

                <!-- 指定人员权限 -->
                <div id="container-item-permission-specific" class="container-item-hidden">
                    <div class="container-item">
                        <div class="container-item-title">
                            <p>💡为人员配置权限：</p>
                        </div>
                    </div>
                    <!-- 权限规则列表 -->
                    <div class="permission-rules-container">
                        <div class="permission-rules-header">
                            <span class="rule-header-item">部门</span>
                            <span class="rule-header-item">用户</span>
                            <span class="rule-header-item">权限</span>
                        </div>
                        <div class="permission-rules-list" id="permission-rules-list">
                            <!-- 动态列表 -->
                        </div>

                        <!-- 添加权限规则按钮 -->
                        <button id="add-rule-btn" class="add-rule-btn">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            添加权限规则
                        </button>
                        
                        <!-- 当前规则预览 -->
                        <div class="rule-preview-container">
                            <div class="rule-preview-title">当前规则预览:</div>
                            <div class="rule-preview-list" id="rule-preview-list">
                              <!-- 动态列表 -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="luckysheet-modal-dialog-footer">
                <div class="other-user"> 
                    <span>其他用户:</span>
                    <select id="other-user-permission-select" class="permission-select">
                        <option value="view">仅查看</option>
                        <option value="edit">可编辑</option>
                        <option value="none">不可查看</option>
                    </select>
                </div>
                <button id="cancel-btn" data-type="cancel">取消</button>
                <button id="confirm-btn" data-type="confirm">确定</button>
            </div>
        </div> `;
}

/**
 * @description 处理弹窗样式
 */
function handleModalStyle() {
    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");
    const modalWidth = $modal.outerWidth();
    const modalHeight = $modal.outerHeight();
    const winWidth = $(window).width();
    const winHeight = $(window).height();
    const scrollLeft = $(document).scrollLeft();
    const scrollTop = $(document).scrollTop();

    const left = (winWidth + scrollLeft - modalWidth) / 2;
    const top = (winHeight + scrollTop - modalHeight) / 2;
    $modal.css({ left, top }).show();
}

/**
 * @description 获取 rule item 的HTML
 */
function getRuleItemHtml(ruleId) {
    return `
        <div class="permission-rule-item" id="${ruleId}">
            <select class="rule-select dept-select">
                <!-- 动态列表 -->
                <option value="all">全部部门</option>
            </select>
        
            <select class="rule-select user-select">
                <option value="all">全部用户</option>
            </select>
            <select class="rule-select permission-select">
                <option value="edit">可编辑</option>
                <option value="view">仅查看</option>
                <option value="none">不可查看</option>
            </select>
            <button class="rule-delete-btn">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
        </div>`;
}

/**
 * @description 检查是否有配置单元格保护的权限
 * @returns
 */
function hasProtectPermission() {
    const cellProtectOptions = luckysheetConfigsetting.cellProtectOptions;

    if (!cellProtectOptions || !cellProtectOptions.permissions) {
        return true;
    }

    // 不然从对象中解析当前用户信息
    const userInfo = cellProtectOptions.userInfo;
    const { depId, roleId, userId } = userInfo;

    const permissions = cellProtectOptions.permissions;
    const { depIds = [], roleIds = [], userIds = [] } = permissions;

    return depIds.includes(depId) || roleIds.includes(roleId) || userIds.includes(userId);
}

/**
 * @description 仅我可编辑 / 指定人员权限 切换事件
 * @param {*} mode
 */
function switchMode(mode) {
    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");
    // 使用 toggle active 处理激活样式，并且切换 container-item 的显示隐藏
    $("#mode-only-me").toggleClass("active", mode === "onlyme");
    $("#mode-specific").toggleClass("active", mode === "specific");

    // 处理 #container-item-permission-onlyme #container-item-permission-specific 的显示隐藏切换
    // 通过 toggle .container-item-hidden 类实现显示隐藏切换
    const onlyme = $modal.find("#container-item-permission-onlyme");
    const specific = $modal.find("#container-item-permission-specific");
    onlyme.toggleClass("container-item-hidden", mode === "specific");
    specific.toggleClass("container-item-hidden", mode === "onlyme");
}

/**
 * @description 关闭弹窗
 */
function closeDialog() {
    $("#luckysheet-modal-dialog-cell-protect-config").remove();
    $("#luckysheet-modal-dialog-mask").hide();
}

/**
 * @description 动态处理权限规则预览
 */
function dynamicPermissionRules() {
    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");
    const $previewList = $modal.find("#rule-preview-list");
    $previewList.empty();

    // 这里需要根据 rule-item 循环生成
    const ruleItems = $modal.find(".permission-rule-item");
    // view edit none
    ruleItems.each((index, item) => {
        // badge 颜色 取得是 permission-select 的 value 值
        const permissionColor = $(item).find(".permission-select").val();
        // badge 文本 取得是 permission-select 的 option 文本
        const permissionText = $(item).find(".permission-select option:selected").text();

        // 取部门的 txt 值
        const deptText = $(item).find(".dept-select option:selected").text();
        // 取用户的 txt 值
        const userText = $(item).find(".user-select option:selected").text();

        const ruleItem = `
            <div class="rule-preview-item">
                <span class="permission-badge ${permissionColor}">${permissionText}</span>
                <span>${deptText} 的 ${userText}</span>
            </div>`;

        $previewList.append(ruleItem);
    });
}

/**
 * @description 删除一条权限规则项
 */
function removePermissionRuleItem(ruleId) {
    $(`#${ruleId}`).remove();
    // 刷新预览
    dynamicPermissionRules();
}

/**
 * @description 添加一条权限规则项
 */
function addPermissionRuleItem() {
    // ! 在应用程序内部，请不要缓存任何数据，因为不能提供刷新时机，缓存应该交由外部实现

    const ruleId = `rule-item-${Math.random().toString(36).substring(2) + Date.now()}`;
    const ruleItemHTML = getRuleItemHtml(ruleId);

    // 这里需要异步请求部门下拉数据
    const cellProtectOptions = luckysheetConfigsetting.cellProtectOptions;

    if (cellProtectOptions && cellProtectOptions.getDepartmentOptions && typeof cellProtectOptions.getDepartmentOptions === "function") {
        cellProtectOptions.getDepartmentOptions().then((options) => {
            handleDepartmentSelect(ruleId, options);
        });
    }

    // 使用 await 的话，需要先添加 DOM 元素，再处理部门下拉，否则数据加不上，找不到DOM
    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");
    $modal.find("#permission-rules-list").append(ruleItemHTML);

    // 绑定删除事件
    $modal
        .find(`#${ruleId} .rule-delete-btn`)
        .off("click")
        .on("click", () => removePermissionRuleItem(ruleId));

    // 绑定 permission-select
    $modal.find(`#${ruleId} .permission-select`).off("change").on("change", dynamicPermissionRules);

    // 刷新预览
    dynamicPermissionRules();
}

/**
 * @description 处理部门选择框
 */
function handleDepartmentSelect(ruleId, options) {
    const $select = $(`#${ruleId} .dept-select`);
    $select.empty();
    // 添加全部部门选项
    $select.append(`<option value="all">全部部门</option>`);
    options.forEach((option) => {
        $select.append(`<option value="${option.value}">${option.label}</option>`);
    });
    $select.val("all");

    // 同时，这里还需要同步绑定用户选择框的事件
    handleDepartmentSelectChange(ruleId);
}

/**
 * @description 处理部门选择框变化事件
 */
function handleDepartmentSelectChange(ruleId) {
    const $select = $(`#${ruleId} .dept-select`);

    $select.off("change").on("change", (e) => {
        const selectedDepId = $(e.target).val();
        // console.log(`部门选择框变化事件：${ruleId} - ${selectedDepId}`);
        // 当用户选择某一个具体的部门后，才能进行人员选择 - 这是，需要请求用户下拉选项
        if (selectedDepId === "all") {
            // 清除当前 user 的所有 options 并且保留 全部用户选项
            $(`#${ruleId} .user-select`).empty().append(`<option value="all">全部用户</option>`);
        } else if (selectedDepId) {
            const cellProtectOptions = luckysheetConfigsetting.cellProtectOptions;
            if (!cellProtectOptions || !cellProtectOptions.getUserOptions || typeof cellProtectOptions.getUserOptions !== "function") {
                return;
            }

            // 这里需要异步请求用户下拉数据
            cellProtectOptions.getUserOptions(selectedDepId).then((options) => {
                handleUserSelect(ruleId, options);
            });
        }

        // 刷新预览
        dynamicPermissionRules();
    });
}

/**
 * @description 处理用户选择框
 */
function handleUserSelect(ruleId, options) {
    // 处理用户选择框
    const $select = $(`#${ruleId} .user-select`);
    $select.empty();
    // 添加全部用户选项
    $select.append(`<option value="all">全部用户</option>`);
    options.forEach((option) => {
        $select.append(`<option value="${option.value}">${option.label}</option>`);
    });
    $select.val("all");

    // 每次选择用户之后，刷新预览
    $select.off("change").on("change", dynamicPermissionRules);
}

/**
 * @description 内部调用打开保护弹窗方法
 * @param {*} range 选区范围
 */
function openProtectDialog(rangeText = "") {
    // 先清除旧的弹窗实例
    $("#luckysheet-modal-dialog-cell-protect-config").remove();
    $("#luckysheet-modal-dialog-mask").hide();

    // 渲染弹窗内容
    const modalHtml = getModalHtml(rangeText);
    $("body").append(modalHtml);
    $("#luckysheet-modal-dialog-mask").show();

    // 处理弹窗样式
    handleModalStyle();
}

/**
 * @description 绑定弹窗事件
 */
function bindEvents(confirmHandler) {
    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");

    // 仅我可编辑 / 指定人员权限
    $modal.find("#mode-only-me").on("click", () => switchMode("onlyme"));
    $modal.find("#mode-specific").on("click", () => switchMode("specific"));

    // 添加权限规则按钮点击事件
    $modal.find("#add-rule-btn").on("click", addPermissionRuleItem);

    // 关闭按钮
    $modal.find("#cancel-btn").on("click", closeDialog);
    // 确认按钮
    $modal.find("#confirm-btn").on("click", () => {
        confirmHandler();
        closeDialog();
    });
}

/**
 * @description 根据页面内容，解析生成权限规则
 */
function parsePermissionRules() {
    const rules = [];
    // 场景1：全部部门 的全部人员 仅查看
    //     {
    //         depId: "all", // "all" 表示全部部门
    //         userId: "all", // "all" 表示全部用户
    //         permission: "view", // "edit" | "view" | "none"
    //     },
    // 场景2：开发部 的全部人员 仅查看
    //     { depId: "dep_001", userId: "all", permission: "view", },
    // 场景3：市场部 的张三 仅查看
    //     { depId: "dep_002", userId: "MVP.SC-2001-0001", permission: "view", },

    const $modal = $("#luckysheet-modal-dialog-cell-protect-config");

    // 这里需要根据 rule-item 循环生成
    const ruleItems = $modal.find(".permission-rule-item");
    // view edit none
    ruleItems.each((index, item) => {
        // badge 文本 取得是 permission-select 的 option 文本
        const permission = $(item).find(".permission-select option:selected").val();
        // 取部门的 txt 值
        const depName = $(item).find(".dept-select option:selected").text();
        const depId = $(item).find(".dept-select option:selected").val();

        // 取用户的 txt 值
        const userName = $(item).find(".user-select option:selected").text();
        const userId = $(item).find(".user-select option:selected").val();

        // 存储名称是为了展示所有保护范围 - 部门 + 用户
        rules.push({ depId, userId, depName, userName, permission });
    });

    // 这里有可能会重复构建权限，需要过滤 这里的重复是指 rules 数组中是否存在相同的 depId 和 userId 及 permission
    return rules.filter(
        (rule, index, self) => self.findIndex((t) => t.depId === rule.depId && t.userId === rule.userId && t.permission === rule.permission) === index,
    );
}

/**
 * @description 获取预览抽屉HTML
 * @returns 预览抽屉HTML
 */
function getPreviewDrawerHtml() {
    return `
        <div id="luckysheet-cell-protect-preview-drawer" class="luckysheet-cell-protect-preview-drawer">
            <div class="drawer-header">
                <span class="drawer-title">查看已保护范围</span>
                <button class="drawer-close-btn" id="drawer-close-btn">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="drawer-content">
                <div class="protection-section">
                    <div class="protection-list" id="protection-list">
                        <!-- 动态渲染保护范围列表 -->
                    </div>
                </div>
            </div>
        </div>
    `;
}

/**
 * @description 获取单个保护范围项的HTML
 * @param {Object} item - 保护范围配置项
 * @param {number} index - 索引
 * @returns 保护范围项HTML
 */
function getProtectionItemHtml(item, index) {
    const itemId = `protection-item-${index}`;
    return `
        <div class="protection-item" id="${itemId}" data-range="${item.range}">
            <div class="protection-item-header">
                <div class="protection-range">${item.range} - ${item.sheetName || "工作表"}</div>
                <div class="protection-item-actions">
                    <button class="action-btn location-btn" data-item-id="${itemId}" title="定位">
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                    </button>
                    <button class="action-btn delete-btn" data-item-id="${itemId}" title="删除">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="protection-item-body">
                ${getProtectionRulesHtml(item)}
            </div>
        </div>
    `;
}

/**
 * @description 获取保护规则展开HTML
 * @param {Object} item - 保护范围配置项
 * @returns 规则展开HTML
 */
function getProtectionRulesHtml(item) {
    let html = "";

    if (item.mode === "onlyme") {
        const otherPermission = item.otherUserPermission || "view";
        html = `
            <div class="rule-item">
                <span class="rule-permission badge-edit">可编辑</span>
                <span class="rule-target">仅自己</span>
            </div>
            <div class="rule-item">
                <span class="rule-permission ${getPermissionBadgeClass(otherPermission)}">${getPermissionText(otherPermission)}</span>
                <span class="rule-target">其他用户</span>
            </div>
        `;
    } else if (item.mode === "specific") {
        if (item.rules && item.rules.length > 0) {
            item.rules.forEach((rule) => {
                const deptName = rule.depName || (rule.depId === "all" ? "全部部门" : rule.depId);
                const userName = rule.userName || (rule.userId === "all" ? "全部用户" : rule.userId);
                html += `
                    <div class="rule-item">
                        <span class="rule-permission ${getPermissionBadgeClass(rule.permission)}">${getPermissionText(rule.permission)}</span>
                        <span class="rule-target">${deptName}${userName}</span>
                    </div>
                `;
            });
        }

        const otherPermission = item.otherUserPermission || "view";
        html += `
            <div class="rule-item">
                <span class="rule-permission ${getPermissionBadgeClass(otherPermission)}">${getPermissionText(otherPermission)}</span>
                <span class="rule-target">其他用户</span>
            </div>
        `;
    }

    return html;
}

/**
 * @description 获取权限文本
 * @param {string} permission - 权限类型
 * @returns 权限文本
 */
function getPermissionText(permission) {
    switch (permission) {
        case "edit":
            return "可编辑";
        case "view":
            return "仅查看";
        case "none":
            return "不可查看";
        default:
            return "未知";
    }
}

/**
 * @description 获取权限徽章样式类
 * @param {string} permission - 权限类型
 * @returns 样式类名
 */
function getPermissionBadgeClass(permission) {
    switch (permission) {
        case "edit":
            return "badge-edit";
        case "view":
            return "badge-view";
        case "none":
            return "badge-none";
        default:
            return "badge-view";
    }
}

/**
 * @description 获取保护范围描述文本
 * @param {Object} item - 保护范围配置项
 * @returns 描述文本
 */
function getProtectionDesc(item) {
    if (item.mode === "onlyme") {
        const otherPermission = item.otherUserPermission || "view";
        let otherDesc = "";
        switch (otherPermission) {
            case "edit":
                otherDesc = "其他协作人可编辑";
                break;
            case "view":
                otherDesc = "其他协作人可查看";
                break;
            case "none":
                otherDesc = "其他协作人不可查看";
                break;
        }
        return `仅自己可编辑，${otherDesc}`;
    } else if (item.mode === "specific") {
        const otherPermission = item.otherUserPermission || "view";
        let otherDesc = "";
        switch (otherPermission) {
            case "edit":
                otherDesc = "其他协作人可编辑";
                break;
            case "view":
                otherDesc = "其他协作人可查看";
                break;
            case "none":
                otherDesc = "其他协作人不可查看";
                break;
        }
        return `${item.rules?.length || 0}条规则，${otherDesc}`;
    }
    return "";
}

/**
 * @description 打开预览抽屉
 */
function openPreviewDrawer() {
    // 先清除旧的抽屉实例
    $("#luckysheet-cell-protect-preview-drawer").remove();

    // 渲染抽屉内容
    const drawerHtml = getPreviewDrawerHtml();
    $("body").append(drawerHtml);

    // 渲染保护范围列表
    renderProtectionList();

    // 绑定事件
    bindPreviewDrawerEvents();

    // 显示遮罩和抽屉
    $("#luckysheet-cell-protect-preview-drawer").addClass("show");

    // 重新重置大小
    luckysheetsizeauto();
}

/**
 * @description 关闭预览抽屉
 */
function closePreviewDrawer() {
    $("#luckysheet-cell-protect-preview-drawer").remove();

    luckysheetsizeauto();
}

/**
 * @description 渲染保护范围列表
 */
function renderProtectionList() {
    const $list = $("#protection-list");
    $list.empty();

    // 获取当前sheet的保护配置
    const sheetIndex = getSheetIndex(Store.currentSheetIndex);
    let file = Store.luckysheetfile[sheetIndex];
    let cellProtectConfig = file.cellProtectConfig || [];

    if (!cellProtectConfig.length) {
        $list.append(`<div class="empty-state">暂无保护范围</div>`);
        return;
    }

    cellProtectConfig.forEach((item, index) => {
        // 添加工作表名称
        item.sheetName = Store.luckysheetfile[sheetIndex]?.name || "工作表";
        const itemHtml = getProtectionItemHtml(item, index);
        $list.append(itemHtml);
    });
}

/**
 * @description 绑定预览抽屉事件
 */
function bindPreviewDrawerEvents() {
    // 返回按钮
    $("#drawer-back-btn").on("click", closePreviewDrawer);

    // 关闭按钮
    $("#drawer-close-btn").on("click", closePreviewDrawer);

    // 遮罩点击关闭
    $("#luckysheet-cell-protect-preview-mask").on("click", closePreviewDrawer);

    // 定位按钮
    $(document).on("click", ".location-btn", function () {
        const itemId = $(this).data("item-id");
        const $item = $(`#${itemId}`);
        const range = $item.data("range");
        if (range) {
            // 设置选中范围
            setRangeShow(range);
        }
    });

    // 删除按钮
    $(document).on("click", ".delete-btn", function () {
        const itemId = $(this).data("item-id");
        const $item = $(`#${itemId}`);
        const range = $item.data("range");
        if (range) {
            deleteProtectionRange(range);
            $item.remove();
            // 检查列表是否为空
            if ($("#protection-list .protection-item").length === 0) {
                $("#protection-list").html(`<div class="empty-state">暂无保护范围</div>`);
            }
        }
    });

    // 开关切换
    $("#protection-toggle").on("click", function () {
        $(this).toggleClass("active");
    });
}

/**
 * @description 删除保护范围
 * @param {string} range - 保护范围
 */
function deleteProtectionRange(range) {
    const sheetIndex = getSheetIndex(Store.currentSheetIndex);
    let file = Store.luckysheetfile[sheetIndex];
    let cellProtectConfig = file.cellProtectConfig || [];

    if (cellProtectConfig.length) {
        cellProtectConfig = cellProtectConfig.filter((item) => item.range !== range);
        file.cellProtectConfig = cellProtectConfig;
    }

    // 删除的话无关其他的属性，只需要 range 及 sheetIndex 即可
    broadcastCellProtect({ range }, sheetIndex, "delete");

    // 刷新表格
    luckysheetrefreshgrid();
}

/**
 * @description 绘制斜线填充的矩形区域
 * @param {CanvasRenderingContext2D} ctx - Canvas 上下文
 * @param {number} startX - 起始 X 坐标
 * @param {number} startY - 起始 Y 坐标
 * @param {number} width - 宽度
 * @param {number} height - 高度
 */
function drawDiagonalLines(ctx, startX, startY, width, height) {
    ctx.save();

    // 最后绘制一个矩形范围即可
    ctx.fillStyle = "rgba(0,0,0,0.015)";
    ctx.fillRect(startX, startY, width, height);

    // 当前缩放比例
    const zoomRatio = Store.zoomRatio;
    const step = 10 * zoomRatio; // 斜线间隔

    ctx.strokeStyle = "rgba(0,0,0,0.08)";
    ctx.lineWidth = 1;
    ctx.lineCap = "round";

    // 创建裁剪区域，限制绘制范围在矩形内
    ctx.beginPath();
    ctx.rect(startX, startY, width, height);
    ctx.clip();

    // 使用旋转绘制斜线，确保所有斜线有相同斜率
    ctx.translate(startX, startY); // 移动坐标系到矩形的左上角
    ctx.rotate(Math.PI / 4); // 旋转角度，45度，可根据需要调整

    // 计算在旋转坐标系中需要绘制的线段范围
    // 确保在旋转后仍能覆盖整个矩形区域
    const diagLen = Math.sqrt(width * width + height * height); // 矩形对角线长度
    const sinVal = Math.abs(Math.sin(Math.PI / 4));
    const cosVal = Math.abs(Math.cos(Math.PI / 4));

    // 计算旋转后矩形的边界
    const maxX = width * cosVal + height * sinVal;
    const maxY = width * sinVal + height * cosVal;

    // 在旋转坐标系中绘制斜线
    ctx.beginPath();
    for (let x = -maxY; x <= maxX; x += step) {
        // 绘制从 (x, -maxY) 到 (x, maxY) 的直线，在原始坐标系中表现为斜线
        ctx.moveTo(x, -maxY);
        ctx.lineTo(x, maxY);
    }

    ctx.stroke();
    ctx.restore();
}

/**
 * @description 将当前添加单元格保护的消息广播其他客户端
 * @param {*} cellProtectItem 单元格保护配置
 * @param {*} sheet_index sheet 索引
 * @param {*} type 操作类型 - add 或 remove 或 update
 */
function broadcastCellProtect(cellProtectItem, sheet_index, type) {
    if (!server.allowUpdate) return;
    server.saveParam("cp", sheet_index || Store.currentSheetIndex, cellProtectItem, { op: type });
}

export { hasProtectPermission, openProtectDialog, bindEvents, parsePermissionRules, drawDiagonalLines, openPreviewDrawer, broadcastCellProtect };
